"use client";

import { cn } from "@workspace/frontend-ui";
import HeroPlaylistThumb from "./HeroPlaylistThumb";
import type { HighlightedGameSlide } from "./types";

type Props = {
  slide: HighlightedGameSlide;
  providerName: string;
  isSelected: boolean;
  progress: number;
  onSelect: () => void;
};

const HeroPlaylistRow: FC<Props> = ({
  slide,
  providerName,
  isSelected,
  progress,
  onSelect,
}) => (
  <li className="flex min-h-0">
    <button
      type="button"
      onClick={onSelect}
      aria-current={isSelected}
      className={cn(
        "relative isolate flex w-full items-center gap-3 overflow-hidden rounded-xl p-3 text-left transition-colors h-19",
        isSelected
          ? "bg-secondary"
          : "cursor-pointer bg-background hover:bg-secondary",
      )}
    >
      {isSelected && (
        <span
          aria-hidden="true"
          data-slot="hero-playlist-progress"
          className="pointer-events-none absolute inset-0 -z-10 origin-left bg-foreground/8 rtl:origin-right"
          style={{ transform: `scaleX(${progress})` }}
        />
      )}
      <HeroPlaylistThumb
        thumbnailUrl={slide.thumbnailUrl}
        alt=""
        isSelected={isSelected}
        isProvider={slide.isProvider}
      />
      <span className="flex min-w-0 flex-1 flex-col gap-0.5">
        <span className="truncate font-semibold text-foreground text-sm/5">
          {slide.title}
        </span>
        {!slide.isProvider && (
          <span className="truncate text-foreground/60 text-xs/4">
            {providerName}
          </span>
        )}
      </span>
    </button>
  </li>
);

export default HeroPlaylistRow;
